module.exports = __webpack_public_path__ + "img/softwareag-booth-video.71c5821e.png";